import React from 'react'

import {
  AlignItems,
  Body2,
  BorderStyle,
  Box,
  Color,
  Icon,
  IconVariant,
  Space,
  ScreenReaderLiveRegion,
  Bold,
} from '@gousto-internal/citrus-react'
import { RadiusScale } from '@gousto-internal/citrus-react/dist/theme/tokens'

import {
  formatTimeLeft,
  useTimeLeftToCheckOut,
} from 'routes/Checkout/Components/CheckoutUrgency/checkoutUrgencyUtils'

/**
 * Displays banner during every check out step saying "Checkout within {timeLeft} to avoid losing your recipes".
 */

export const UrgencyBanner = () => {
  const timeLeft = useTimeLeftToCheckOut()

  const { time, unit } = formatTimeLeft(timeLeft)

  return (
    <ScreenReaderLiveRegion urgency="polite">
      <Box paddingV={[2, 2, 4, 4]} paddingH={[2, 2, null]}>
        <Box
          display="flex"
          bg={Color.Warning_50}
          borderStyle={BorderStyle.Solid}
          borderColor={Color.Warning_100}
          borderWidth={0.5}
          borderRadius={3 as RadiusScale}
          paddingV={2}
          paddingH={2}
          alignItems={AlignItems.Center}
        >
          <Icon name="time" variant={IconVariant.Error} />
          <Space size={1} direction="horizontal" />
          <Box paddingV={1}>
            <Body2>
              Complete checkout within{' '}
              <Bold>
                {time} {unit}
              </Bold>{' '}
              to grab your recipes before they sell out!
            </Body2>
          </Box>
        </Box>
      </Box>
    </ScreenReaderLiveRegion>
  )
}
